import { useLanguage } from '../../../hooks/useLanguage';

export default function FooterNew() {
  const { language } = useLanguage();

  const content = {
    de: {
      copyright: '© 2026 TELIQone. Alle Rechte vorbehalten.',
      links: ['Impressum', 'Datenschutz', 'Kontakt', 'LinkedIn']
    },
    en: {
      copyright: '© 2026 TELIQone. All rights reserved.',
      links: ['Imprint', 'Privacy', 'Contact', 'LinkedIn']
    }
  };

  const t = content[language];

  return (
    <footer className="relative py-12 bg-black border-t border-white/10">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <img
              src="https://static.readdy.ai/image/517d8e45247682e1e610f69e9004e6d7/27d85eeddc9e07e72840b82b740df7b1.svg"
              alt="TELIQone"
              className="h-6 w-auto"
            />
            <span className="text-white text-base font-bold tracking-tight">
              TELIQ<span className="text-blue-500">one</span>
            </span>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6">
            <a
              href="/impressum"
              className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              {t.links[0]}
            </a>
            <a
              href="/datenschutz"
              className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              {t.links[1]}
            </a>
            <a
              href="/contact"
              className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              {t.links[2]}
            </a>
            <a
              href="https://www.linkedin.com/company/omniit-gmbh/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1"
            >
              <i className="ri-linkedin-fill"></i>
              {t.links[3]}
            </a>
          </div>

          <p className="text-sm text-white/40">{t.copyright}</p>
        </div>
      </div>
    </footer>
  );
}